

// k13-lite-bg-img 背景图轮播 start
(function () {
  const swiperEl = document.querySelector('.k13-lite-bg-img-swiper');
  if (!swiperEl) return;

  new Swiper('.k13-lite-bg-img-swiper', {
    pagination: {
      el: '.k13-lite-bg-img-swiper-pagination',
      clickable: true,
    },
    speed: 1000,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    slidesPerView: 1,
    autoplay: {
      delay: 2000,
      disableOnInteraction: false,
    },
    loop: true,
  });
})();

(function () {
  const swiperEl = document.querySelector('.k13-lite-bg-img-swiper-2');
  if (!swiperEl) return;

  new Swiper('.k13-lite-bg-img-swiper-2', {
    pagination: {
      el: '.k13-lite-bg-img-swiper-pagination-2',
      clickable: true,
    },
    speed: 1000,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    slidesPerView: 1,
    autoplay: {
      delay: 3000,
      disableOnInteraction: false,
    },
    loop: true,
  });
})();

const images = [
  [
    'https://cdn.shopify.com/s/files/1/0509/3454/6613/files/0101.png?v=1755761193',
    'https://cdn.shopify.com/s/files/1/0509/3454/6613/files/0201_6f224cdf-16c1-41c9-9f6b-64e970b7779e.png?v=1755761652',
    'https://cdn.shopify.com/s/files/1/0509/3454/6613/files/0301.png?v=1755761916',
    'https://cdn.shopify.com/s/files/1/0509/3454/6613/files/0401.png?v=1755761958',
    'https://cdn.shopify.com/s/files/1/0509/3454/6613/files/0501.png?v=1755761990',
    'https://cdn.shopify.com/s/files/1/0509/3454/6613/files/0601.png?v=1755762019',
    'https://cdn.shopify.com/s/files/1/0509/3454/6613/files/0701.png?v=1755762042',
    'https://cdn.shopify.com/s/files/1/0509/3454/6613/files/0801.png?v=1755762061',
  ],
  [
    'https://cdn.shopify.com/s/files/1/0509/3454/6613/files/0102.png?v=1755761193',
    'https://cdn.shopify.com/s/files/1/0509/3454/6613/files/0202.png?v=1755761652',
    'https://cdn.shopify.com/s/files/1/0509/3454/6613/files/0302.png?v=1755761916',
    'https://cdn.shopify.com/s/files/1/0509/3454/6613/files/0402.png?v=1755761958',
    'https://cdn.shopify.com/s/files/1/0509/3454/6613/files/0502.png?v=1755761990',
    'https://cdn.shopify.com/s/files/1/0509/3454/6613/files/0602.png?v=1755762018',
    'https://cdn.shopify.com/s/files/1/0509/3454/6613/files/0702.png?v=1755762042',
    'https://cdn.shopify.com/s/files/1/0509/3454/6613/files/0802.png?v=1755762061',
  ],
  [
    'https://cdn.shopify.com/s/files/1/0509/3454/6613/files/0103.png?v=1755761193',
    'https://cdn.shopify.com/s/files/1/0509/3454/6613/files/0203.png?v=1755761652',
    'https://cdn.shopify.com/s/files/1/0509/3454/6613/files/0303.png?v=1755761916',
    'https://cdn.shopify.com/s/files/1/0509/3454/6613/files/0403.png?v=1755761958',
    'https://cdn.shopify.com/s/files/1/0509/3454/6613/files/0503.png?v=1755761990',
    'https://cdn.shopify.com/s/files/1/0509/3454/6613/files/0603.png?v=1755762018',
    'https://cdn.shopify.com/s/files/1/0509/3454/6613/files/0703.png?v=1755762042',
    'https://cdn.shopify.com/s/files/1/0509/3454/6613/files/0803.png?v=1755762061',
  ],
  [
    'https://cdn.shopify.com/s/files/1/0509/3454/6613/files/0104.png?v=1755761193',
    'https://cdn.shopify.com/s/files/1/0509/3454/6613/files/0204.png?v=1755761652',
    'https://cdn.shopify.com/s/files/1/0509/3454/6613/files/0304.png?v=1755761916',
    'https://cdn.shopify.com/s/files/1/0509/3454/6613/files/0404.png?v=1755761958',
    'https://cdn.shopify.com/s/files/1/0509/3454/6613/files/0504.png?v=1755761990',
    'https://cdn.shopify.com/s/files/1/0509/3454/6613/files/0604.png?v=1755762018',
    'https://cdn.shopify.com/s/files/1/0509/3454/6613/files/0704.png?v=1755762042',
    'https://cdn.shopify.com/s/files/1/0509/3454/6613/files/0804.png?v=1755762061',
  ],
  [
    'https://cdn.shopify.com/s/files/1/0509/3454/6613/files/0105.png?v=1755761193',
    'https://cdn.shopify.com/s/files/1/0509/3454/6613/files/0205.png?v=1755761652',
    'https://cdn.shopify.com/s/files/1/0509/3454/6613/files/0305.png?v=1755761916',
    'https://cdn.shopify.com/s/files/1/0509/3454/6613/files/0405.png?v=1755761958',
    'https://cdn.shopify.com/s/files/1/0509/3454/6613/files/0505.png?v=1755761990',
    'https://cdn.shopify.com/s/files/1/0509/3454/6613/files/0605.png?v=1755762018',
    'https://cdn.shopify.com/s/files/1/0509/3454/6613/files/0705.png?v=1755762042',
    'https://cdn.shopify.com/s/files/1/0509/3454/6613/files/0805.png?v=1755762061',
  ],
  [
    'https://cdn.shopify.com/s/files/1/0509/3454/6613/files/0106.png?v=1755761193',
    'https://cdn.shopify.com/s/files/1/0509/3454/6613/files/0206.png?v=1755761652',
    'https://cdn.shopify.com/s/files/1/0509/3454/6613/files/0306.png?v=1755761916',
    'https://cdn.shopify.com/s/files/1/0509/3454/6613/files/0406.png?v=1755761958',
    'https://cdn.shopify.com/s/files/1/0509/3454/6613/files/0506.png?v=1755761990',
    'https://cdn.shopify.com/s/files/1/0509/3454/6613/files/0606.png?v=1755762018',
    'https://cdn.shopify.com/s/files/1/0509/3454/6613/files/0706.png?v=1755762042',
    'https://cdn.shopify.com/s/files/1/0509/3454/6613/files/0806.png?v=1755762061',
  ],
  [
    'https://cdn.shopify.com/s/files/1/0509/3454/6613/files/0107.png?v=1755761193',
    'https://cdn.shopify.com/s/files/1/0509/3454/6613/files/0207.png?v=1755761652',
    'https://cdn.shopify.com/s/files/1/0509/3454/6613/files/0307.png?v=1755761916',
    'https://cdn.shopify.com/s/files/1/0509/3454/6613/files/0407.png?v=1755761958',
    'https://cdn.shopify.com/s/files/1/0509/3454/6613/files/0507.png?v=1755761990',
    'https://cdn.shopify.com/s/files/1/0509/3454/6613/files/0607.png?v=1755762018',
    'https://cdn.shopify.com/s/files/1/0509/3454/6613/files/0707.png?v=1755762042',
    'https://cdn.shopify.com/s/files/1/0509/3454/6613/files/0807.png?v=1755762061',
  ],
  [
    'https://cdn.shopify.com/s/files/1/0509/3454/6613/files/0108.png?v=1755761193',
    'https://cdn.shopify.com/s/files/1/0509/3454/6613/files/0208.png?v=1755761652',
    'https://cdn.shopify.com/s/files/1/0509/3454/6613/files/0308.png?v=1755761916',
    'https://cdn.shopify.com/s/files/1/0509/3454/6613/files/0408.png?v=1755761958',
    'https://cdn.shopify.com/s/files/1/0509/3454/6613/files/0508.png?v=1755761990',
    'https://cdn.shopify.com/s/files/1/0509/3454/6613/files/0608.png?v=1755762018',
    'https://cdn.shopify.com/s/files/1/0509/3454/6613/files/0708.png?v=1755762042',
    'https://cdn.shopify.com/s/files/1/0509/3454/6613/files/0808.png?v=1755762061',
  ],
];

let currentDesignIndex = 0;
let currentMaterialsIndex = 0;
let mainImageEl = null;

function updateMainImage() {
  if (mainImageEl) {
    mainImageEl.src = images[currentDesignIndex][currentMaterialsIndex];
  }
}

function initK13LitePage() {
  const learnMoreBtn = document.querySelector('.learn-more-btn');
  const hiddenRows = document.querySelectorAll('.mobile-hidden-new');
  const faqContainer = document.querySelector('.ugc-faq-container-content');
  const videoElements = document.querySelectorAll('[data-fancybox="video"]');
  const designImgs = document.querySelectorAll('.k13-lite-can-really-do-content-options-item-design');
  const materialsImgs = document.querySelectorAll('.k13-lite-can-really-do-content-options-item-materials');
  const tabs = document.querySelectorAll('.k13-lite-parameter-table-tab');
  const productImg = document.querySelector('.k13-lite-parameter-table-product-img');
  const whatsInTheBoxWrapper = document.querySelector('.whats-in-the-box-wrapper');
  const whatsInTheBoxContainerContentImg = document.querySelector('.whats-in-the-box-container-content-img img');

  mainImageEl = document.getElementById('k13-lite-can-really-do-main-img');

  if (learnMoreBtn) {
    learnMoreBtn.addEventListener('click', function () {
      const isExpanded = learnMoreBtn.classList.toggle('expanded');
      hiddenRows.forEach((row) => {
        row.style.display = isExpanded ? 'flex' : 'none';
      });
      learnMoreBtn.innerHTML = isExpanded
        ? 'Show less<svg xmlns="http://www.w3.org/2000/svg" width="10" height="7" viewBox="0 0 10 7" fill="none"><path d="M9 6L5 1L1 6" stroke="#fff" stroke-linecap="round" stroke-linejoin="round"/></svg>'
        : 'Learn more <svg xmlns="http://www.w3.org/2000/svg" width="10" height="7" viewBox="0 0 10 7" fill="none"><path d="M9 1L5 6L1 1" stroke="#fff" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    });
  }

  if (faqContainer) {
    faqContainer.addEventListener('click', function (event) {
      const question = event.target.closest('.ugc-faq-container-content-item-question');
      if (!question) return;
      event.preventDefault();
      const item = question.closest('.ugc-faq-container-content-item');
      if (!item) return;
      const active = item.classList.contains('active');
      faqContainer.querySelectorAll('.ugc-faq-container-content-item').forEach((el) => el.classList.remove('active'));
      if (!active) {
        item.classList.add('active');
      }
    });

    faqContainer.addEventListener(
      'touchstart',
      function (event) {
        const question = event.target.closest('.ugc-faq-container-content-item-question');
        if (!question) return;
        event.preventDefault();
        question.click();
      },
      { passive: false }
    );
  }

  if (videoElements.length && window.jQuery && jQuery.fancybox) {
    $('[data-fancybox="video"]').fancybox({
      type: 'iframe',
      iframe: {
        css: {
          width: '100%',
          height: '100%',
        },
      },
      beforeLoad: function (instance, slide) {
        let url = slide.src;
        if (url.indexOf('youtu.be') !== -1) {
          const videoId = url.split('youtu.be/')[1];
          slide.src = 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&rel=0';
        } else if (url.indexOf('youtube.com/watch') !== -1) {
          let videoId = url.split('v=')[1];
          const ampersandPosition = videoId.indexOf('&');
          if (ampersandPosition !== -1) {
            videoId = videoId.substring(0, ampersandPosition);
          }
          slide.src = 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&rel=0';
        }
      },
      afterClose: function () {
        $('.fancybox-iframe').attr('src', '');
      },
    });
  }

  if (designImgs.length) {
    designImgs.forEach((el) => {
      el.addEventListener('click', function () {
        designImgs.forEach((item) => item.classList.remove('active'));
        el.classList.add('active');
        currentDesignIndex = parseInt(el.getAttribute('data-design-index'), 10) || 0;
        updateMainImage();
      });
    });
  }

  if (materialsImgs.length) {
    materialsImgs.forEach((el) => {
      el.addEventListener('click', function () {
        materialsImgs.forEach((item) => item.classList.remove('active'));
        el.classList.add('active');
        currentMaterialsIndex = parseInt(el.getAttribute('data-materials-index'), 10) || 0;
        updateMainImage();
      });
    });
  }

  if (tabs.length) {
    tabs.forEach((tab) => {
      tab.addEventListener('click', function () {
        tabs.forEach((item) => {
          item.classList.remove('is-active');
          item.setAttribute('aria-selected', 'false');
        });
        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');

        const newImg = tab.getAttribute('data-img');
        const newPackedImg = tab.getAttribute('data-packed-img');
        if (productImg && newImg) {
          productImg.src = newImg;
        }
        if (whatsInTheBoxContainerContentImg && newPackedImg) {
          whatsInTheBoxContainerContentImg.src = newPackedImg;
        }
        if (whatsInTheBoxWrapper) {
          whatsInTheBoxWrapper.classList.toggle('pink', tab.getAttribute('data-color') === 'pink');
        }
      });
    });
  }

  updateMainImage();
}

function getSlidesOffsetBefore() {
  const winWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  if (winWidth >= 1920) {
    return 360;
  }
  if (winWidth <= 1024) {
    return 0;
  }
  return Math.round(360 * (winWidth / 1920));
}

let k13_lite_customers_are_saying_swiper_container_swiper = null;
function initk13_lite_customers_are_saying_swiper_container_swiper() {
  if (k13_lite_customers_are_saying_swiper_container_swiper) {
    k13_lite_customers_are_saying_swiper_container_swiper.destroy(true, true);
  }
  const container = document.querySelector('.k13-lite-customers-are-saying-swiper-container');
  if (!container) return;

  k13_lite_customers_are_saying_swiper_container_swiper = new Swiper('.k13-lite-customers-are-saying-swiper-container', {
    slidesPerView: 4.1,
    spaceBetween: 20,
    navigation: {
      nextEl: '#k13-lite-customers-are-saying-nextButton',
      prevEl: '#k13-lite-customers-are-saying-prevButton',
    },
    slidesOffsetBefore: getSlidesOffsetBefore(),
    loopedSlides: 10,
    observer: true,
    observeParents: true,
    on: {
      init: updateNavigationButtons,
      slideChange: updateNavigationButtons,
    },
    breakpoints: {
      1024: {
        slidesPerView: 3.5,
        spaceBetween: 15,
        slidesOffsetBefore: 0,
      },
      768: {
        slidesOffsetBefore: 24,
        slidesOffsetAfter: 24,
        slidesPerView: 1.2,
        spaceBetween: 12,
      },
    },
  });
}

function updateNavigationButtons() {
  const prevButton = document.getElementById('k13-lite-customers-are-saying-prevButton');
  const nextButton = document.getElementById('k13-lite-customers-are-saying-nextButton');
  if (!k13_lite_customers_are_saying_swiper_container_swiper || !prevButton || !nextButton) return;
  prevButton.disabled = k13_lite_customers_are_saying_swiper_container_swiper.isBeginning;
  nextButton.disabled = k13_lite_customers_are_saying_swiper_container_swiper.isEnd;
}

let resizeTimeout = null;
function handleResize() {
  if (resizeTimeout) {
    clearTimeout(resizeTimeout);
  }
  resizeTimeout = setTimeout(function () {
    if (window.innerWidth > 1024) {
      initk13_lite_customers_are_saying_swiper_container_swiper();
    }
  }, 150);
}

window.addEventListener('DOMContentLoaded', function () {
  initK13LitePage();
  initk13_lite_customers_are_saying_swiper_container_swiper();
  window.addEventListener('resize', handleResize);
});
